import { action } from 'typesafe-actions';
import { GiroWebappError } from '../../../model/error';
import { OrganizationChat } from '../../../model/organization';
import { OrganizationChatActionTypes } from './types';

export const organizationChatRequest = () => action(OrganizationChatActionTypes.ORGANIZATION_CHAT_REQUEST);
export const organizationChatSuccess = (response: OrganizationChat) => action(OrganizationChatActionTypes.ORGANIZATION_CHAT_SUCCESS, response);
export const organizationChatError = (error: GiroWebappError) => action(OrganizationChatActionTypes.ORGANIZATION_CHAT_ERROR, error);